import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { SERVICE_METHODS } from "../../utils/AppEnumerations";
import { DOCUMENT_TYPE_ENUM } from "../../utils/PurchaseEnumerations";
import { dayEndUtc, dayStartUtc } from "../../utils/PurchaseFormat";
import { paginationParams, toQueryString } from "../../utils/QueryString";

export interface IPaymentOrderFilter {
  status: string | null;
  order_kind: string | null;
  credit_type: string | null;
  firm_id: string | null;
  from_date: string | null;
  to_date: string | null;
}

export const GET_ALL_PAYMENT_ORDER = (
  pagination: IPagination,
  search: string,
  filter: IPaymentOrderFilter
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_payment_order.url +
      toQueryString({
        ...paginationParams(pagination),
        search,
        ...filter,
        from_date: dayStartUtc(filter.from_date),
        to_date: dayEndUtc(filter.to_date),
      }),
    API_ENDPOINTS.get_all_payment_order.method
  );

export const GET_PAYMENT_ORDER_DETAIL = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_payment_order_detail.url(id),
    API_ENDPOINTS.get_payment_order_detail.method
  );

export const DOWNLOAD_SIGNED_FILE = (url: string) =>
  serviceMaker(url, SERVICE_METHODS.GET_CONFIG, {}, { responseType: "blob" });

export const GET_PAYMENT_ORDER_DOCUMENT = (
  id: string,
  documentType: DOCUMENT_TYPE_ENUM
) =>
  serviceMaker(
    API_ENDPOINTS.get_payment_order_document.url(id, documentType),
    API_ENDPOINTS.get_payment_order_document.method
  );
